import BranchFundingSourceHolidayAllComponent from './branch_funding_source_holiday.all.component';

let BranchFundingSourceHolidayAllModule = angular.module('branchFundingSourceHolidayAll', [])

    .component('branchFundingSourceHolidayAll', BranchFundingSourceHolidayAllComponent)

    .name;

export default BranchFundingSourceHolidayAllModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/all/index.js